import React, { useCallback } from 'react';
import { ExternalProvider } from '../../../../../lib';
import { Phone } from 'react-bootstrap-icons';
import { useExternalAuth } from '../../../../pages/PatientDetails/context/ExternalAuthProvider';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { usePatientProfile } from '../../hooks';
import { LoadingSpinner } from '../../../LoadingSpinner';

interface ExternalProviderButtonProps {
  providers: ExternalProvider[];
}
const ExternalProviderButton = ({ providers }: ExternalProviderButtonProps) => {
  const { startAuth, isGettingAuthUrl } = useExternalAuth();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const { externalConnections } = usePatientProfile();

  const checkProviderConnectivity = (provider: ExternalProvider) =>
    Boolean(
      externalConnections?.find(
        (item) => item.provider === provider.toUpperCase(),
      )?.status === 'ACTIVE',
    );

  const checkProviderValidSetup = useCallback(
    (provider: ExternalProvider) => {
      const enabledProviders: string[] =
        selectedTenancy?.features?.integrations?.providers ?? [];

      const enabledProvidersNormalized = enabledProviders.map((p) =>
        String(p).toLowerCase(),
      );

      return enabledProvidersNormalized.includes(provider.toLowerCase());

      // More generic way for future, TBC
      // return enabledProviders.includes(provider.toLowerCase());
    },
    [selectedTenancy],
  );

  return (
    <div className="d-flex flex-column gap-2">
      {providers.map((provider) => {
        if (!checkProviderValidSetup(provider)) {
          return null;
        }

        const isConnected = checkProviderConnectivity(provider);

        return isConnected ? (
          <div className="d-flex justify-content-end">{provider} connected</div>
        ) : (
          <button
            style={{ opacity: isGettingAuthUrl ? 0.5 : 1 }}
            disabled={isGettingAuthUrl}
            key={provider}
            onClick={() => startAuth(provider)}
            className="d-flex align-items-center gap-2"
          >
            <span
              style={{
                fontSize: '14px',
                fontWeight: '400',
                fontFamily: 'Roboto Condensed',
              }}
            >
              Connect to {provider}
            </span>
            {isGettingAuthUrl ? (
              <LoadingSpinner showText={false} size={18} />
            ) : (
              <Phone size={18} />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ExternalProviderButton;
